<template>
  <v-container>
    <v-tabs>
      <v-tab>
        <v-badge
          :content="pmsBooksToSync.length"
          :value="pmsBooksToSync.length"
        >Appointment Books to Synchronize</v-badge>
      </v-tab>
      <v-tab-item>
        <v-scale-transition>
          <v-alert type="info" class="md6" v-if="!pmsBooksToSync.length">Please add some appointment books to the sync process.</v-alert>
        </v-scale-transition>
        <v-list>
          <template v-for="(item, index) in pmsBooksToSync">
            <v-list-item :key="item.selectedMh1BookId+'Linked'">
              <v-list-item-icon>
                <v-icon>mdi-calendar-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="getBookDisplayName(item)"></v-list-item-title>
              <v-list-item-subtitle>{{getResouceDescription(item)}}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item :key="item.selectedMh1BookId+'Connection'">
              <v-list-item-icon>
                <v-icon>mdi-transit-connection</v-icon>
              </v-list-item-icon>

              <v-list-item-action>
                <v-btn icon @click="showBookInfo(item)">
                  <v-icon color="info lighten-2">mdi-information</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon @click="removeFromSync(item)" v-on="on">
                      <v-icon color="warning">mdi-cloud-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>Remove {{getBookDisplayName(item)}} from Synchronization</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :key="item.selectedMh1BookId+'olbAcc'">
              <v-list-item-icon>
                <v-img :src="require('@/assets/mh1_icon.png')" width="32"></v-img>
              </v-list-item-icon>
              <v-list-item-title>
                <a
                  :href="mh1BaseUri + 'appointmentBook/edit/' + item.selectedMh1BookId"
                  target="_blank"
                >{{getMh1AppBookName(item.selectedMh1BookId)}}</a>
                <v-icon x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
              </v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item>

            <v-divider v-if="index < pmsBooksToSync.length" :key="index+'spacer'" :inset="false"></v-divider>
          </template>
        </v-list>
      </v-tab-item>

      <v-tab>
        <v-badge
          :content="booksAvailableForSync.length"
          :value="booksAvailableForSync.length"
        >PMS Books at {{selectedSite.name}}</v-badge>
      </v-tab>
      <v-tab-item>
        <span v-if="this.pmsInfo && this.pmsInfo.baseSlotSize && this.pmsInfo.baseSlotSize != 'PT0S'">
          PMS Default Slot Size: {{displaySlotSize(this.pmsInfo.baseSlotSize)}}
        </span>
        <span v-if="this.selectedSite && this.selectedSite.baseSlotSize && this.selectedSite.baseSlotSize != 'PT0S'">
          Site Default Slot Size: {{displaySlotSize(this.selectedSite.baseSlotSize)}} 
        </span>
        <v-list two-line subheader>
          <v-list-item v-for="item in booksAvailableForSync" :key="item.book.pmsBookFQId">
            <v-list-item-content>
              <v-list-item-title v-text="getBookDisplayName(item)"></v-list-item-title>
              <v-list-item-subtitle>Slot Size: {{displaySlotSize(getBookSlotSize(item))}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click="showBookInfo(item)">
                <v-icon color="info lighten-2">mdi-information</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="addToSync(item)"
                    v-on="on"
                    :disabled="isLoading"
                    :loading="isLoading"
                  >
                    <v-icon color="primary ">mdi-cloud-upload</v-icon>
                  </v-btn>
                </template>
                <span>Synchronize {{getBookDisplayName(item)}}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-tab-item>

      <v-tab>
        <v-badge
          :content="availableMh1AppointmentBooks.length"
          :value="availableMh1AppointmentBooks.length"
        >Unsynchronized MH1 Books</v-badge>
      </v-tab>
      <v-tab-item>
        <v-list two-line subheader>
          <v-list-item v-for="item in availableMh1AppointmentBooks" :key="item.id">
            <v-list-item-content>
              <v-list-item-title v-text="item.subscriber.name + ' ' + item.subscriber.surname "  v-bind:style="{ color: getColor(item.status) }" ></v-list-item-title>
              <v-list-item-subtitle >Slot Size: {{displaySlotSize(item.slotSize)}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click="showMh1BookInfo(item)">
                <v-icon color="info lighten-1">mdi-information</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>          
        </v-list>
      </v-tab-item>
    </v-tabs>

    <!-- Unsynchronized MH1 Books -->
  </v-container>
</template>
<script>
import AddBookDialog from "./AddBookDialog";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

const iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;

export default {
  name: "SelectBooks",
  props: {
    value: Object,
    index: Number,
    pmsInfo: Object,
  },
  data: function () {
    return {
      pmsBooksToSync: [],
      isLoading: false,
      mh1BooksForPractice: [],
      mh1ServiceTypes: [],
      initPmsBooksToSync: false,
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
    };
  },
  created: async function () {
    // this is always valid as one feature has to be selected
    await this.getServiceTypes();
    console.log("selectbooks created after getServiceTypes");
    this.$emit("step-is-valid", 1);
    console.log("selectbooks created after emit");

    if (
      this.value?.existingMh1PracticeId &&
      this.value?.newOrExisting == "existing"
    ) {
      console.log(
        "SelectBooks created has valid details, getting practice books"
      );
      await this.retrieveMh1AppointmentBooks(this.value.existingMh1PracticeId);
    }

    if (this.value.mode == "manage" && this.value.pmsBooksToSync) {
      this.pmsBooksToSync = this.value.pmsBooksToSync;
    } else {
      this.initPmsBooksToSync = true;
    }

    console.log("selectbooks created end");
  },
  watch: {
    value: async function (newVal, oldVal) {
      if (
        newVal.newOrExisting == "existing" &&
        newVal.existingMh1PracticeId &&
        newVal.existingMh1PracticeId != oldVal.existingMh1PracticeId
      ) {
        console.log(
          "selectbooks watch getting mh1 books",
          newVal.newOrExisting,
          newVal.existingMh1PracticeId,
          oldVal.existingMh1PracticeId
        );
        await this.retrieveMh1AppointmentBooks(newVal.existingMh1PracticeId);
      }
    },
    pmsBooksToSync: {
      handler: function (newVal, oldVal) {
        console.log(
          "SelectBooks watch pmsBoksToSync ",
          newVal,
          oldVal,
          this.initPmsBooksToSync
        );

        // don't trigger the update on inital create
        if (!this.initPmsBooksToSync) {
          this.initPmsBooksToSync = true;
          return;
        }
        this.$emit("input", {
          ...this.value,
          pmsBooksToSync: this.pmsBooksToSync,
        });
      },
    },
    "value.existingMh1PracticeId": {
      async handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          console.log("Practice ID changed:", newVal, oldVal);
          try {
            await this.retrieveMh1AppointmentBooks(newVal);
          } catch (err) {
            console.error("Failed to fetch books:", err);
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    getColor: function (status) {
      if(status === 'ACTIVE') {}
       else {return 'red'}
    },
    async retrieveMh1AppointmentBooks(practiceId) {
      this.isLoading = true;
      try {
        const mh1GetBooksResult = await API.graphql(
          graphqlOperation(queries.getMh1PracticeAppointmentBooks, {
            practiceId,
          })
        );

        console.log("retrieveMh1AppointmentBooks got", mh1GetBooksResult);

        if (!mh1GetBooksResult?.data?.getMh1PracticeAppointmentBooks) {
          console.log(
            "retrieveMh1AppointmentBooks did not get results",
            mh1GetBooksResult
          );
          this.mh1BooksForPractice = [];
          return;
        }

        this.mh1BooksForPractice =
          mh1GetBooksResult.data.getMh1PracticeAppointmentBooks;
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },
    getNamesForBook: function (book) {
      const bookResourceIds = book.pmsResourceIds;
      const resources =
        bookResourceIds
          ?.map((bookResourceId) =>
            this?.pmsInfo?.resources?.find(
              (r) => r.pmsResourceId == bookResourceId
            )
          )
          ?.filter((n) => n) ?? [];

      if (!resources || !resources?.length) {
        return book.pmsAppointmentBookId;
      }
      const names =
        resources?.map((r) => {
          return `${r.title ?? ""} ${r.name ?? ""} ${r.firstName ?? ""} ${
            r.surname ?? ""
          } ${r.abbreviation ? " - " + r.abbreviation : ""}`;
        }) ?? [];
      return names?.join(", ");
    },
    getBookDisplayName: function (bi) {
      return (
        bi.book.name ??
        bi.resources
          ?.map((r) => {
            if (r.name) {
              return `${r.title ?? ""} ${r.name ?? ""}`;
            } else {
              return `${r.title ?? ""} ${r.firstName ?? ""} ${r.surname ?? ""}`;
            }
          })
          ?.join(", ") ??
        "" ??
        bi.book.pmsBookFQId
      );
    },
    getResouceDescription: function (bi) {
      return (
        bi.resources
          ?.map(
            (r) =>
              [r.position ?? "", r.resourceType ?? ""]
                ?.filter((a) => a)
                ?.join(" - ") ?? []
          )
          ?.join(", ") ?? ""
      );
    },
    getSlotSize: function(bi) {
      console.log("getSlotSize for", bi);
      if (bi.book.baseSlotSize && bi.book.baseSlotSize != "PT0S") {
        console.log("getSlotSize bi.book.baseSlotSize", bi.book.baseSlotSize);
        return bi.book.baseSlotSize;
      }

      if (bi.resouces?.length > 0) {
        console.log("getSlotSize bi.resouces.length > 0");
          const uniqueSlotSizes = [...new Set(bi.resources.map(r => r.baseSlotSize).filter(s => !!s) ?? [])];

        console.log("getSlotSize uniqueSlotSizes", uniqueSlotSizes);
          if (uniqueSlotSizes.length == 1) {
            return uniqueSlotSizes[0];
          }
      }

      console.log("getSlotSize this.selectedSite?.baseSlotSize || this.pmsInfo?.baseSlotSize || ", this.selectedSite?.baseSlotSize, this.pmsInfo?.baseSlotSize);
      return this.selectedSite?.baseSlotSize || this.pmsInfo?.baseSlotSize || "";
    },
    getBookSlotSize: function(bi) {
      console.log("getSlotSize for", bi);
      if (bi.book.baseSlotSize && bi.book.baseSlotSize != "PT0S") {
        console.log("getSlotSize bi.book.baseSlotSize", bi.book.baseSlotSize);
        return bi.book.baseSlotSize;
      }

      if (bi.resouces?.length > 0) {
        console.log("getSlotSize bi.resouces.length > 0");
          const uniqueSlotSizes = [...new Set(bi.resources.map(r => r.baseSlotSize).filter(s => !!s) ?? [])];

        console.log("getSlotSize uniqueSlotSizes", uniqueSlotSizes);
          if (uniqueSlotSizes.length == 1) {
            return uniqueSlotSizes[0];
          }
      }
      return "";
    },
tryParseISO8601Duration: function(value) {
      try {
        const matches = value.match(iso8601DurationRegex);

        const r = {
            sign: matches[1] === undefined ? '+' : '-',
            years: matches[2] === undefined ? 0 : matches[2],
            months: matches[3] === undefined ? 0 : matches[3],
            weeks: matches[4] === undefined ? 0 : matches[4],
            days: matches[5] === undefined ? 0 : matches[5],
            hours: matches[6] === undefined ? 0 : matches[6],
            minutes: matches[7] === undefined ? 0 : matches[7],
            seconds: matches[8] === undefined ? 0 : matches[8]
        };

        console.log("tryParseISO8601DurationToHoursMinutes matched", value, r);

        return r;

        return `${r.hours?.toString().padStart(2,'0') || "00"}:${r.minutes?.toString().padStart(2,'0') || "00"}`;
      }
      catch(err){
        console.log("tryParseISO8601DurationToMinutes err", value, err)
        return value;
      }
    },
    displaySlotSize: function(value) {
      if (!value) return "Not detected";
      const mins = this.tryParseISO8601DurationToMinutes(value);
      const minsInt = parseInt(mins);
      if (!minsInt) {
        return "Not detected";
      }
      else {
        return `${mins} minute` + (minsInt ? 's' : '');
      }
    },
    tryParseISO8601DurationToHoursMinutes: function(value) {
      const r = this.tryParseISO8601Duration(value);

      if (r == value) {
        return r;
      }

      return `${r.hours?.toString().padStart(2,'0') || "00"}:${r.minutes?.toString().padStart(2,'0') || "00"}`;
    },
    tryParseISO8601DurationToMinutes: function(value) {
      const r = this.tryParseISO8601Duration(value);

      if (r == value) {
        return r;
      }

      return Number(r.minutes) + (Number(r.hours) * 60) + (Number(r.days) * 24 * 60);
    },
    showBookInfo: function (bi) {
      this.$dialog.warning({
        text: JSON.stringify(bi, null, 4),
        title: `${this.getBookDisplayName(bi)} - Raw Info`,
        icon: "mdi-information",
        type: "primary",
        actions: ["Ok"],
      });
      return;
    },
    showMh1BookInfo: function (bi) {
      this.$dialog.warning({
        text: JSON.stringify(bi, null, 4),
        title: `${bi.subscriber.name} ${bi.subscriber.surname} - Raw Info`,
        icon: "mdi-information",
        type: "primary",
        actions: ["Ok"],
      });
      return;
    },

    addToSync: async function (bi) {
      const result = await this.$dialog.showAndWait(
        AddBookDialog,
        {
          value: bi,
          width: 800,
          availableMh1AppointmentBooks: this.availableMh1AppointmentBooks,
          siteWeeklySchedule:
            this.selectedSite?.openingHours?.weeklySchedule ?? {},
          serviceTypes: this.mh1ServiceTypes,
          serviceTypesLoading: this.isLoading,
          siteBaseSlotSize: this.selectedSite?.baseSlotSize ?? "",
          pmsBaseSlotSize: this.pmsInfo?.baseSlotSize ?? "",
          siteTimeZone: this.selectedSite?.timeZone ?? "",
        },
        { width: 800 }
      );
      if (result?.action == "ok") {
        //console.log("adding book ", result);
        this.pmsBooksToSync.push(result);
      }
    },
    removeFromSync: async function (bi) {
      const res = await this.$dialog.confirm({
        text:
          "Do you really want to disable online appointments for this book?",
        title: "Warning",
      });
      if (res) {
        this.pmsBooksToSync = this.pmsBooksToSync?.filter((b) => b != bi) ?? [];
      }
    },
    async getServiceTypes() {
      console.log("getservicetypes called");
      const getMh1ServiceTypesNarrow = /* GraphQL */ `
        query GetMh1ServiceTypes {
          getMh1ServiceTypes {
            id
            name
            orderBy
          }
        }
      `;

      this.isLoading = true;
      try {
        const searchResult = await API.graphql(
          graphqlOperation(getMh1ServiceTypesNarrow)
        );

        console.log("getServiceTypes got", searchResult);

        if (!searchResult?.data?.getMh1ServiceTypes) {
          console.log("did not get results", searchResult);
          this.mh1ServiceTypes = [];
          return;
        }

        this.mh1ServiceTypes =
          searchResult.data.getMh1ServiceTypes?.sort((s) => s.orderBy) ?? [];
      } catch (err) {
        console.log("getServiceTypes err", err);
      } finally {
        this.isLoading = false;
      }
    },
    getMh1AppBookName(mh1AppointmentBookId) {
      const foundBook = this.mh1BooksForPractice.find(
        (ab) => ab.id == mh1AppointmentBookId
      );
      console.log(
        "getMh1AppBookName",
        mh1AppointmentBookId,
        foundBook,
        this.mh1BooksForPractice
      );
      if (!foundBook) return mh1AppointmentBookId;

      return [foundBook.subscriber?.name ?? "", foundBook.subscriber?.surname ?? ""].join(" ") || mh1AppointmentBookId;
    },
  },
  filters: {},
  computed: {
    selectedSite: function () {
      return (
        this.pmsInfo?.sites?.find(
          (s) => s.pmsSiteId == this.value.selectedSiteId
        ) ?? {}
      );
    },
    booksAvailableForSync: function () {
      const resourcesForBook = this.bookInfoForSite;
      return (
        resourcesForBook?.filter(
          (b) =>
            !this.pmsBooksToSync.find(
              (bi) => bi.book.pmsBookFQId == b.book.pmsBookFQId
            )
        ) ?? []
      );
    },
    bookInfoForSite: function () {
      const resourcesForBook = this.selectedSite.appointmentBooks?.map((b) => {
        const resourcesForBook =
          b.pmsResourceIds
            ?.map((bookResourceId) =>
              this?.pmsInfo?.resources?.find(
                (r) => r.pmsResourceId == bookResourceId
              )
            )
            ?.filter((n) => n) ?? [];

        return {
          book: b,
          resources: resourcesForBook,
        };
      });
      return resourcesForBook;
    },
    availableMh1AppointmentBooks: function () {
      console.log(
        "selectbooks computed availableMh1AppointmentBooks",
        this.mh1BooksForPractice
      );
      if ((this.mh1BooksForPractice?.length ?? 0) == 0) {
        return [];
      }

      const result = this.mh1BooksForPractice.filter((mb) => {
        return !this.pmsBooksToSync.find(
          (sb) =>
            sb.newOrExisting == "existing" && sb.selectedMh1BookId == mb.id
        );
      });

      console.log(
        "selectbooks computed availableMh1AppointmentBooks result",
        result
      );

      return result;
    },    
  },
};
</script>